import React from 'react';
import TwoColumnsActionCardGrid from 'components/ActionCards/TwoColumnActionCardGrid';
import { unwrapSingleton } from 'helpers/csTypeProcessors';
import { handleAndTrackLinkClick } from 'helpers/navigation';
import { StyledActionCard } from '../styles';
import { ActionCardsBlockProps } from '../types';

const TwoColumnsActionCardsBlock: React.FC<ActionCardsBlockProps> = ({
  action_cards,
}) => (
  <TwoColumnsActionCardGrid className="actionCards" id={action_cards.html_id}>
    {action_cards.action_cards.map(
      ({ href, icon, heading, subheading, body, disabled, chevron_icon }, index) => (
        <StyledActionCard
          key={`${heading}-${index}`}
          data-cy={`CustomActionCard${index}`}
          href={href}
          icon={unwrapSingleton(icon)?.icon_code}
          heading={heading}
          subheading={subheading ?? undefined}
          body={body ?? undefined}
          onClick={handleAndTrackLinkClick(href, 'CustomActionCards', heading)}
          disabled={disabled}
          chevronIcon={unwrapSingleton(chevron_icon)?.icon_code}
        />
      )
    )}
  </TwoColumnsActionCardGrid>
);
export default React.memo(TwoColumnsActionCardsBlock);
